import { memo } from 'react';
import { useApiContext } from 'react-easyrocket';
import { useWindowSize } from 'src/modules/store/windowSizeStore';
import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import { DepositButton } from 'src/components/Header/components/DepositButton';
import { LanguagesSelector } from 'src/modules/locales/components/Languages/components/LanguagesSelector';
import { LogInIcon } from 'src/svg/LogInIcon';
import { Search } from 'src/components/Search';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';

const _HeaderButtonsBlock = () => {
  const { isAuthenticated } = useApiContext();
  const { is768 } = useWindowSize('is768');
  const { startRegistration, startLogin } = useAuthFlow();

  const { t } = useTranslation();

  return (
    <div className="flex justify-end items-center gap-2.5">
      {is768 && <Search compact />}
      {isAuthenticated ? (
        <DepositButton />
      ) : (
        <>
          {is768 ? (
            <Button
              label={`${t('general.logIn')}`}
              mode="button-secondary"
              className="768:min-w-[160px]"
              onClick={() => startLogin({ defaultFlow: false })}>
              {t('general.logIn')}
            </Button>
          ) : (
            <button className="border border-h_login_button border-solid rounded-[4px] p-2">
              <LogInIcon className="text-h_login_button" onClick={() => startLogin()} />
            </button>
          )}
          <Button
            mode="button-primary"
            title={`${t('general.signUp')}`}
            label={`${t('general.signUp')}`}
            onClick={() => startRegistration()}
            className="768:min-w-[160px]"
          />
        </>
      )}
      {is768 && <LanguagesSelector compact />}
    </div>
  );
};

export const HeaderButtonsBlock = memo(_HeaderButtonsBlock);
